import { getAllowRole } from "@/utils/get-roles.js";
import { createRouter, createWebHistory } from "vue-router";
import store from "@/store";
import ErrorPage from "../views/error-page/Main.vue";
import HouseHold from "../views/01house-hold/index.vue";
import DashboardOverview1 from "../views/dashboard-overview-1/Main.vue";
import DashboardOverview2 from "../views/dashboard-overview-2/Main.vue";
import LandingPage from "../views/landing-page/Main.vue";
import FamilyPage from "../views/family/index.vue";
import MemberPage from "../views/member/index.vue";
import HouseHoldProfile from "../views/01house-hold/Profile.vue";
import AddMember from "../views/member/AddMember.vue";
import FamilyProfile from "../views/family/Profile.vue";
import MemberProfile from "../views/member/Profile.vue";
import CSGAPITEST from "../views/member/CSGAPITEST.vue"; //CSG TEST API
import BORAAPITEST from "../views/member/BORAAPITEST.vue"; //BORA TEST API
import VolunteerPage from "../views/volunteer-page/index.vue";
import UserProfile from "../views/user-profile/index.vue";
import ReportPage from "../views/report/index.vue";
import Report2Page from "../views/report-2/index.vue";
import Report3Page from "../views/report-3/index.vue";
import Report4Page from "../views/report-4/index.vue";
import Report5Page from "../views/report-5/index.vue";
import { Route } from "vue-router";
import MemberPlan from "../views/member/Plan.vue";
import PivotTable from "../views/pivot-table/index.vue";
import News from "../views/news-management/index.vue";
import UserManagement from "../views/user-management/index.vue";
import UserHCMManagement from "../views/user-management/HcmUser.vue";
import DashboardOverview from "../views/dashboard/dashboard-overview/index.vue";
import DashboardAreaTest1 from "../views/dashboard-area/Main.vue";
import DashboardAreaTest2 from "../views/dashboard-area/Main2.vue";
import HouseHoldDashboard from "../views/01house-hold/Main.vue";
import NewsDetail from "../views/news/index.vue";
import LinkageCenter from "../views/linkage-center/index.vue";

const routes = [
  {
    path: "/household",
    name: "main-house-hold",
    component: HouseHold,
    meta: {
      requiresAuth: true,
      allowRoles: getAllowRole("main-house-hold"),
    },
  },
  {
    path: "/",
    name: "landing-page",
    component: LandingPage,
  },
  {
    path: "/side-menu-dashboard-overview-1",
    name: "side-menu-dashboard-overview-1",
    component: DashboardOverview1,
  },
  {
    path: "/side-menu-dashboard-overview-2",
    name: "side-menu-dashboard-overview-2",
    component: DashboardOverview2,
  },
  {
    path: "/family",
    name: "family-page",
    meta: {
      requiresAuth: true,
      allowRoles: getAllowRole("family-page"),
    },
    component: FamilyPage,
  },
  {
    path: "/member",
    name: "member-page",
    component: MemberPage,
    meta: {
      requiresAuth: true,
      allowRoles: getAllowRole("member-page"),
    },
  },
  {
    path: "/external/welfare",
    name: "welfare-page",
    beforeEnter(to, from, next) {
      window.open("https://all-welfares.m-society.go.th/", "_blank");
      next(false);
    },
  },
  {
    path: "/family/:famid/member/add",
    name: "add-member",
    component: AddMember,
    meta: {
      requiresAuth: true,
      allowRoles: getAllowRole("add-member"),
    },
  },
  {
    path: "/household/:hhid",
    name: "household-profile",
    component: HouseHoldProfile,
    meta: {
      requiresAuth: true,
      allowRoles: getAllowRole("household-profile"),
    },
  },
  {
    path: "/family/:famid",
    name: "family-profile",
    component: FamilyProfile,
    meta: {
      requiresAuth: true,
      allowRoles: getAllowRole("family-profile"),
    },
  },
  {
    path: "/member/:mid",
    name: "member-profile",
    component: MemberProfile,
    meta: {
      requiresAuth: true,
      allowRoles: getAllowRole("member-profile"),
    },
  },
  {
    path: "/CSGAPITEST",
    name: "CSGAPITEST",
    component: CSGAPITEST
  },
  {
    path: "/BORAAPITEST",
    name: "BORAAPITEST",
    component: BORAAPITEST
  },
  {
    path: "/member/:mid/plan",
    name: "member-plan",
    component: MemberPlan,
    meta: {
      requiresAuth: true,
      allowRoles: getAllowRole("member-plan"),
    },
  },
  {
    path: "/volunteer",
    name: "volunteer-page",
    meta: {
      requiresAuth: true,
      allowRoles: getAllowRole("volunteer-page"),
    },
    component: VolunteerPage,
  },
  {
    path: "/profile",
    name: "user-profile",
    meta: {
      requiresAuth: true,
      allowRoles: getAllowRole("user-profile"),
    },
    component: UserProfile,
  },
  {
    path: "/error-page",
    name: "error-page",
    component: ErrorPage,
  },
  {
    path: "/report",
    name: "report-page-1",
    component: ReportPage,
    meta: {
      requiresAuth: true,
      allowRoles: getAllowRole("report-page-1"),
    },
  },
  {
    path: "/report-2",
    name: "report-page-2",
    component: Report2Page,
    meta: {
      requiresAuth: true,
      allowRoles: getAllowRole("report-page-2"),
    },
  },
  {
    path: "/report-3",
    name: "report-page-3",
    component: Report3Page,
    meta: {
      requiresAuth: true,
      allowRoles: getAllowRole("report-page-3"),
    },
  },
  {
    path: "/report-4",
    name: "report-page-4",
    component: Report4Page,
    meta: {
      requiresAuth: true,
      allowRoles: getAllowRole("report-page-4"),
    },
  },
  // {
  //   path: "/report-5",
  //   name: "report-page-5",
  //   component: Report5Page,
  //   meta: {
  //     requiresAuth: true,
  //     allowRoles: getAllowRole("report-page-5"),
  //   },
  // },
  {
    path: "/pivot-table",
    name: "pivot-table",
    component: PivotTable,
    meta: {
      requiresAuth: true,
      allowRoles: getAllowRole("pivot-table"),
    },
  },
  {
    path: "/news-management",
    name: "news",
    component: News,
    meta: {
      requiresAuth: true,
      allowRoles: getAllowRole("news"),
    },
  },
  {
    path: "/users",
    name: "user-management",
    component: UserManagement,
    meta: {
      requiresAuth: true,
      allowRoles: getAllowRole("user-management"),
    },
  },
  {
    path: "/users-hcm",
    name: "user-hcm-management",
    component: UserHCMManagement,
    meta: {
      requiresAuth: true,
      allowRoles: getAllowRole("user-hcm-management"),
    },
  },
  {
    path: "/dashboard-overview",
    name: "dashboard-overview",
    component: DashboardOverview,
    meta: {
      requiresAuth: true,
      allowRoles: getAllowRole("dashboard-overview"),
    },
  },
  {
    path: "/linkage-center",
    name: "linkage-center",
    component: LinkageCenter,
    meta: {
      requiresAuth: true,
      allowRoles: getAllowRole("linkage-center"),
    },
  },
  { path: "/:pathMatch(.*)*", component: ErrorPage },
  {
    path: "/nnb_test1",
    name: "dashboard_area_test_1",
    component: DashboardAreaTest1,
  },
  {
    path: "/nnb_test2",
    name: "dashboard_area_test_2",
    component: DashboardAreaTest2,
  },
  {
    path: "/household-dashboard",
    name: "household-dashboard",
    component: HouseHoldDashboard,
    meta: {
      requiresAuth: true,
      allowRoles: getAllowRole("household-dashboard"),
    },
  },
  {
    path: "/news/:id",
    name: "news-detail",
    component: NewsDetail,
  },
];

const router = createRouter({
  routes,
  // mode: "history",
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    return (
      savedPosition || {
        left: 0,
        top: 0,
      }
    );
  },
});

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

router.beforeEach(async (to, from, next, globalVariable) => {
  while (
    typeof store.getters["userAuth/getAllKeycloak"].createLoginUrl ==
    "undefined"
  ) {
    await sleep(100);
  }

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (("authenticated", store.getters["userAuth/getAuthenticated"])) {
      let current_user_role = store.getters["userAuth/getUserRoleCode"];
      let page_allow_roles = to.meta.allowRoles;

      if (typeof page_allow_roles != "undefined") {
        if (!page_allow_roles.some((r) => current_user_role == r)) {
          next("/");
        } else {
          next();
        }
      } else {
        next();
      }
    } else {
      if (localStorage.getItem("is_kc_logout_redirect") == "true") {
        localStorage.clear();
        localStorage.setItem("is_kc_logout_redirect", "false");
        window.location.replace(window.location.origin);
      } else {
        if (localStorage.getItem("volunteerData")) {
          localStorage.removeItem("volunteerData");
        }
        const loginUrl = store.getters[
          "userAuth/getAllKeycloak"
        ].createLoginUrl();
        window.location.replace(loginUrl);
      }
    }
  } else {
    next();
  }
});

export default router;
